import type { Song } from "../types";

/**
 * Happy Birthday to You — in the public domain (US since 2016, EU since
 * 2017; verify additional territories before launching outside them).
 */
export const happyBirthday: Song = {
  id: "happy-birthday",
  title: "Happy Birthday",
  bpm: 95,
  instrument: "piano",
  notes: [
    { key: "C4", beats: 0.75 },
    { key: "C4", beats: 0.25 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 2 },
    { key: "C4", beats: 0.75 },
    { key: "C4", beats: 0.25 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 2 },
    { key: "C4", beats: 0.75 },
    { key: "C4", beats: 0.25 },
    { key: "C5", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 2 },
    { key: "Bb4", beats: 0.75 },
    { key: "Bb4", beats: 0.25 },
    { key: "A4", beats: 1 },
    { key: "F4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "F4", beats: 2 },
  ],
};
